import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createBlock as _createBlock, withCtx as _withCtx, withKeys as _withKeys, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-58d54d06"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "btn-block" }
const _hoisted_2 = { style: {"margin-top":"10px"} }

import { SearchContainerGroup } from '@/components/business/crud/widgets/SearchWidgetContainer';
import { ScForm } from '@/models/ScForm';


export default /*#__PURE__*/_defineComponent({
  __name: 'WidgetSearch',
  props: {
    groups: {},
    form: {},
    show: { type: Boolean, default: true }
  },
  emits: ["search"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

function reset() {
  props.form.reset();
  emit('search');
}

function submit() {
  emit('search');
}

return (_ctx: any,_cache: any) => {
  const _component_sc_btn = _resolveComponent("sc-btn")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: "search",
    onKeydown: _cache[0] || (_cache[0] = _withKeys(($event: any) => (submit()), ["enter"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _createVNode(_component_sc_btn, {
          type: "primary",
          style: {"margin-right":"10px"},
          handler: submit,
          text: "查询"
        }),
        _createVNode(_component_sc_btn, {
          disabled: !_ctx.form.canReset.value,
          handler: reset,
          text: "重置"
        }, null, 8, ["disabled"])
      ])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_row, { gutter: [12, 12] }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groups, (group) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: group.title
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.items, (item) => {
                return (_openBlock(), _createBlock(_component_a_col, {
                  xs: 24,
                  sm: 12,
                  md: 8,
                  lg: 8,
                  xl: 8,
                  xxl: 4,
                  key: item.id
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(item.component.value), _normalizeProps(_guardReactiveProps(item.props)), null, 16))
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ], 64))
          }), 128))
        ]),
        _: 1
      })
    ])
  ], 544)), [
    [_vShow, _ctx.show]
  ])
}
}

})